<div
  data-id="search-container"
  class="flex"
  *transloco="let t; scope: 'featureSearch'"
  [ngClass]="{ 'mt-6': store.context() !== 'header' }"
>
  <ng-template #quickFilters>
    @if (!store.filterStoreProperties().aiSearchResultsActive) {
      <bd-quick-filters
        [searchResultsCountsPerScope]="
          store.filterStoreProperties().searchResultsCountPerScope
        "
        [filters]="store.filterStoreProperties().quickFilterOptions"
        (updateFilters)="store.addScopeFilter($event)"
        (advancedFilterVisible)="store.updateAdvancedFilterVisible(true)"
        [searchResultsCountsPerScopeLoading]="
          store.searchResultsCountsPerScopeLoading()
        "
      ></bd-quick-filters>
    }
  </ng-template>
  <div class="flex-1 max-w-full">
    <div #filters>
      @let alignSearchbarLeft =
        !!store.featureFlagsStore.trialExperienceEnabled() &&
        store.context() === 'search';
      <div
        class="flex flex-col"
        [ngClass]="{
          'items-start': alignSearchbarLeft,
          'items-center': !alignSearchbarLeft,
          'bd-drawer-open': store.rightDrawerOpen(),
          'bd-search-context': store.context() === 'search',
          'bd-transition': store.contentDetailsStoreProperties().contentItem,
        }"
      >
        <div
          class="flex items-center gap-4 bd-transition"
          [ngClass]="
            store.rightDrawerOpen() ? 'bd-drawer-open' : 'bd-drawer-closed'
          "
        >
          @let searchTermIsEmpty =
            !this.store.filterStoreProperties().searchTerm ||
            this.store.filterStoreProperties().searchTerm.trim() === '';
          <bd-searchbar
            class="bd-searchbar"
            [context]="store.context()"
            [searchTerm]="
              store.aiSearchToggleOn() &&
              (store.smartFiltersHasError() ||
                store.searchResultsStoreProperties().smartFiltersLoading ||
                searchTermIsEmpty)
                ? store.filterStoreProperties().smartSearchQuery
                : store.filterStoreProperties().searchTerm
            "
            [combinedSuggestions]="
              store.aiSearchToggleOn()
                ? store.smartSearchSuggestions()
                : store.combinedSuggestions()
            "
            (submitSearch)="onSubmitSearch($event)"
            (submitTypeAheadSearch)="store.updateTypeAheadSearchTerm($event)"
            (submitSuggestionFilter)="store.handleSuggestionFilter($event)"
            (submitSmartSuggestion)="store.applySmartSuggestion($event)"
            (submitObjectSuggestion)="store.handleObjectSuggestion($event)"
            (clearSearchInput)="store.clearSearchInput()"
            [aiSearchEnabled]="store.featureFlagsStore.aiSearchEnabled()"
            (aiSearchChange)="onAiSearchChange($event)"
            [aiSearchToggleOn]="store.aiSearchToggleOn()"
            [focusInput]="store.smartFiltersRefineQuery()"
          ></bd-searchbar>
        </div>
        @if (store.context() === 'default') {
          <div class="bd-quick-filters">
            <ng-container *ngTemplateOutlet="quickFilters"></ng-container>
          </div>
        }
      </div>

      @if (store.context() === 'search') {
        <div
          class="flex flex-col bd-page-header-wrapper"
          [ngClass]="{
            'bd-drawer-open': store.rightDrawerOpen(),
          }"
        >
          <bd-page-header
            class="bd-search-content bd-page-header"
            [titleText]="{
              textKey: 'searchResults.searchResultsHeader',
              tScope: 'featureSearch',
            }"
            [actions]="headerActions()"
          >
            <div>
              @if (store.filterStoreProperties().aiSearchResultsActive) {
                <div class="mb-3">
                  <bd-nls-overview-and-feedback
                    [overview]="
                      store.interactiveNlsOverview() ??
                      store.filterStoreProperties().nlsOverview
                    "
                    [editable]="!!store.interactiveNlsOverview()"
                    [coworkerAvailable]="
                      aiAssistantV2Store.aiAssistantButtonEnabled()
                    "
                    (refineWithCoworkerClicked)="openAiCoworker()"
                    (clearFiltersClicked)="onClearFiltersClicked()"
                    (feedbackSent)="onFeedbackSent($event)"
                    (attributeUpdated)="store.updateOverviewAttribute($event)"
                    (simpleValueUpdated)="
                      store.updateOverviewSimpleValue($event)
                    "
                  ></bd-nls-overview-and-feedback>
                </div>
              }
            </div>
          </bd-page-header>
          @if (!store.filterStoreProperties().aiSearchResultsActive) {
            <div class="bd-search-content">
              <div class="mt-0.5 flex min-w-full items-start gap-4">
                <p-button
                  data-id="more-filters"
                  [label]="t('featureSearch.filters')"
                  icon="ui-filter"
                  styleClass="bd-neutral bd-no-capitalize bd-size-small"
                  [text]="true"
                  (onClick)="store.updateAdvancedFilterVisible(true)"
                />
                @if (
                  store.filterStoreProperties().appliedFilters.length > 0 &&
                  !store.searchResultsStoreProperties().searchResultsLoading
                ) {
                  <bd-interactive-applied-filters-container
                    class="min-w-0 flex-1 self-start"
                    [users]="store.users()"
                    [usersLoading]="store.usersLoading()"
                    (searchUsers)="store.updateUsersSearchTerm($event)"
                    (filtersChanged)="store.reloadSearchAfterFilterChange()"
                  />
                } @else if (
                  store.filterStoreProperties().appliedFilters.length > 0
                ) {
                  <div
                    class="flex gap-4 flex-wrap"
                    data-id="applied-filters-loading-skeleton"
                  >
                    @for (
                      filter of store.filterStoreProperties().appliedFilters;
                      track filter.id
                    ) {
                      <p-skeleton width="150px" height="32px"></p-skeleton>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
      <bd-advanced-filter
        [visible]="store.filterStoreProperties().advancedFilterVisible"
        (visibleChange)="store.updateAdvancedFilterVisible($event)"
        [scopeFilterOptions]="
          store.filterStoreProperties().defaultScopeFilterOptions
        "
        [elementTypeFilterOptions]="allElementTypeFilters"
        [selectedAdvancedFilter]="store.filterStoreProperties().advancedFilter"
        [users]="store.users()"
        [usersLoading]="store.usersLoading()"
        [totalSearchResultsCount]="
          store.filterStoreProperties().searchResultsCountInAdvancedFilter
        "
        [searchResultsCountLoading]="
          store.searchResultsStoreProperties().searchResultsLoading ||
          store.filterStoreProperties().searchResultsCountLoading
        "
        (advancedFilterChanged)="store.updateSelectedAdvancedFilter($event)"
        (advancedFilterForCountChanged)="
          store.onAdvancedFilterForCountChanged($event)
        "
        (searchUsers)="store.updateUsersSearchTerm($event)"
        [authenticatedUser]="store.authenticatedUser()"
      >
      </bd-advanced-filter>
    </div>
    @if (store.context() === 'search') {
      <div class="w-full mt-3 bd-split-search-tabs">
        <p-tabs
          data-id="search-tabs"
          [value]="activeTabValue()"
          (valueChange)="onTabChange($event)"
        >
          <p-tablist>
            <p-tab [value]="0" data-id="search-tab-ALL">
              <div class="flex items-center gap-2">
                <span>{{ t('featureSearch.all') }}</span>
              </div>
            </p-tab>
            <p-tab [value]="1" data-id="search-tab-OBJECT">
              <div class="flex items-center gap-2">
                <span>{{ t('featureSearch.quickFilters.object') }}</span>
                <bd-badge
                  data-id="search-tab-count-OBJECT"
                  [label]="
                    getSearchResultsCountForScope(
                      searchScopes.object
                    ).toString()
                  "
                  [type]="anyFilterApplied() ? 'info' : 'count'"
                  [customIcon]="''"
                ></bd-badge>
              </div>
            </p-tab>
            <p-tab [value]="2" data-id="search-tab-VIEW">
              <div class="flex items-center gap-2">
                <span>{{ t('featureSearch.quickFilters.view') }}</span>
                <bd-badge
                  data-id="search-tab-count-VIEW"
                  [label]="
                    getSearchResultsCountForScope(searchScopes.view).toString()
                  "
                  [type]="anyFilterApplied() ? 'info' : 'count'"
                  [customIcon]="''"
                ></bd-badge>
              </div>
            </p-tab>
            <p-tab [value]="3" data-id="search-tab-WORKSPACE">
              <div class="flex items-center gap-2">
                <span>{{ t('featureSearch.quickFilters.workspace') }}</span>
                <bd-badge
                  data-id="search-tab-count-WORKSPACE"
                  [label]="
                    getSearchResultsCountForScope(
                      searchScopes.workspace
                    ).toString()
                  "
                  [type]="anyFilterApplied() ? 'info' : 'count'"
                  [customIcon]="''"
                ></bd-badge>
              </div>
            </p-tab>
          </p-tablist>
          <p-tabpanels>
            <p-tabpanel [value]="0">
              <bd-all-search-results
                [viewItems]="store.viewSearchResultItems()"
                [viewsLoading]="store.viewSearchResultsLoading()"
                [viewsCount]="getSearchResultsCountForScope(searchScopes.view)"
                [workspaceItems]="store.workspaceSearchResultItems()"
                [workspacesLoading]="store.workspaceSearchResultsLoading()"
                [workspacesCount]="
                  getSearchResultsCountForScope(searchScopes.workspace)
                "
                [objectResultItems]="store.searchResultItems()"
                [objectsLoading]="
                  store.searchResultsStoreProperties().searchResultsLoading
                "
                [objectsCount]="
                  getSearchResultsCountForScope(searchScopes.object)
                "
                [manageWorkspaceActionDisabled]="
                  store.manageWorkspaceActionDisabled()
                "
                [manageWorkspaceNoAccessTooltip]="
                  manageWorkspaceNoAccessTooltip
                "
                [objectSelectionMode]="
                  objectSelectionStore.searchResultsGlobalStoreProperties()
                    .isSelectionMode
                "
                [selectedObjectItems]="objectSelectionStore.selectedItems()"
                [filtersHeight]="filtersHeight() + splitTabsOccupiedHeight()"
                [objectResultsMode]="
                  store.featureFlagsStore.objectSearchResultsTableEnabled()
                    ? 'table'
                    : 'list'
                "
                [columnCatalogue]="store.objectResultsColumnCatalogue()"
                [activeItemId]="store.activeItemId()"
                [isDrawerOpen]="store.rightDrawerOpen()"
                (seeAllViews)="onTabChange(viewTabValue)"
                (seeAllWorkspaces)="onTabChange(workspaceTabValue)"
                (seeAllObjects)="onTabChange(objectTabValue)"
                (openView)="onOpenView($event)"
                (openViewDetails)="onOpenViewDetails($event)"
                (copyViewToFrame)="onCopyViewToFrame($event)"
                (copyViewLink)="onCopyViewLink($event)"
                (deleteView)="onDeleteView($event)"
                (openWorkspace)="onOpenWorkspace($event)"
                (openWorkspaceDetails)="onOpenWorkspaceDetails($event)"
                (inviteToWorkspace)="onInviteToWorkspace($event)"
                (copyWorkspaceLink)="onCopyWorkspaceLink($event)"
                (archiveWorkspace)="onArchiveWorkspace($event)"
                (unarchiveWorkspace)="onUnarchiveWorkspace($event)"
                (openSearchResultItem)="onOpenSearchResultItem($event)"
                (deleteSearchResultItem)="onDeleteSearchResultItem($event)"
                (openContentDetails)="onOpenContentDetails($event)"
                (objectItemSelectionToggled)="
                  onAllTabItemSelectionToggled($event)
                "
                (objectSelectedItemsChange)="
                  onAllTabSelectedItemsChange($event)
                "
              ></bd-all-search-results>
            </p-tabpanel>
            <p-tabpanel [value]="1">
              <bd-object-search-results
                [totalSearchResultsCount]="
                  getSearchResultsCountForScope(searchScopes.object)
                "
                [searchResultItems]="store.searchResultItems()"
                [currentSort]="store.objectResultsSorting() ?? undefined"
                (contentOpen)="store.showContentOpen($event)"
                (contentEditData)="
                  store.editDataForObjects($event, store.cancelObjectLoading$)
                "
                (openSearchResultItem)="onOpenSearchResultItem($event)"
                (deleteSearchResultItem)="onDeleteSearchResultItem($event)"
                (openContentDetails)="onOpenContentDetails($event)"
                (reviewAppliedFiltersClick)="
                  store.onReviewAppliedFiltersClick()
                "
                (clearFiltersClick)="onNoResultsClearFiltersClicked()"
                [aiSearchActive]="store.aiSearchToggleOn()"
                [isDrawerOpen]="store.rightDrawerOpen()"
                [activeItemId]="store.activeItemId()"
                [filtersHeight]="filtersHeight() + splitTabsOccupiedHeight()"
                [addToFrameWithoutSelectionEnabled]="
                  store.featureFlagsStore.addToFrameWithoutSelectionEnabled()
                "
                [objectResultsMode]="
                  store.featureFlagsStore.objectSearchResultsTableEnabled()
                    ? 'table'
                    : 'list'
                "
                [columnCatalogue]="store.objectResultsColumnCatalogue()"
                [manageWorkspaceActionDisabled]="
                  store.manageWorkspaceActionDisabled()
                "
                [manageWorkspaceNoAccessTooltip]="
                  manageWorkspaceNoAccessTooltip
                "
                [emptyStateLinks]="objectEmptyStateLinks()"
                (objectSelectionChange)="store.onObjectSelectionChange($event)"
                (switchScope)="onSwitchToScope($event)"
                (pageChange)="onPageChange($event)"
                (sortChange)="onObjectSortChange($event)"
              ></bd-object-search-results>
            </p-tabpanel>
            <p-tabpanel [value]="2">
              <bd-view-search-results
                [viewItems]="store.viewSearchResultItems()"
                [loading]="store.viewSearchResultsLoading()"
                [totalCount]="store.viewTotalCount()"
                [currentPageIndex]="store.viewCurrentPageIndex()"
                [pageSize]="store.searchResultsStoreProperties().pageSize"
                [emptyStateLinks]="viewEmptyStateLinks()"
                [filtersHeight]="filtersHeight() + splitTabsOccupiedHeight()"
                (openView)="onOpenView($event)"
                (openViewDetails)="onOpenViewDetails($event)"
                (copyViewToFrame)="onCopyViewToFrame($event)"
                (copyViewLink)="onCopyViewLink($event)"
                (deleteView)="onDeleteView($event)"
                (switchScope)="onSwitchToScope($event)"
                (pageChange)="onViewPageChange($event)"
              ></bd-view-search-results>
            </p-tabpanel>
            <p-tabpanel [value]="3">
              <bd-workspace-search-results
                [workspaceItems]="store.workspaceSearchResultItems()"
                [loading]="store.workspaceSearchResultsLoading()"
                [totalCount]="store.workspaceTotalCount()"
                [currentPageIndex]="store.workspaceCurrentPageIndex()"
                [pageSize]="store.searchResultsStoreProperties().pageSize"
                [frameCounts]="workspaceFrameCounts()"
                [frameCountsLoading]="workspaceFrameCountsLoading()"
                [emptyStateLinks]="workspaceEmptyStateLinks()"
                [filtersHeight]="filtersHeight() + splitTabsOccupiedHeight()"
                (openWorkspace)="onOpenWorkspace($event)"
                (openWorkspaceDetails)="onOpenWorkspaceDetails($event)"
                (inviteToWorkspace)="onInviteToWorkspace($event)"
                (copyWorkspaceLink)="onCopyWorkspaceLink($event)"
                (archiveWorkspace)="onArchiveWorkspace($event)"
                (unarchiveWorkspace)="onUnarchiveWorkspace($event)"
                (switchScope)="onSwitchToScope($event)"
                (pageChange)="onWorkspacePageChange($event)"
              ></bd-workspace-search-results>
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
      </div>
    }
  </div>
  @if (store.context() === 'search' && store.searchResultItems()) {
    <ng-template
      #detailsDrawer
      bdKey="detailsDrawer"
      [bdDrawer]="detailsDrawer"
      [drawerPosition]="'right'"
      [drawerState]="store.contentDetailsStoreProperties().drawerState"
    >
      <bd-content-details-container
        [showSkeleton]="
          store.contentDetailsStoreProperties().contentItemDetailsLoading
        "
        [contentItemDetails]="
          store.contentDetailsStoreProperties().contentItemDetails
        "
        (drawerClosed)="store.updateIsDrawerOpen(false)"
        [scrollToUsedIn]="store.contentDetailsStoreProperties().scrollToUsedIn"
        [contentDetailsConfiguration]="contentDetailsConfiguration"
        [showFooter]="store.showDrawerFooter()"
        [context]="'search'"
        [actionMenuItemsOverride]="drawerActionMenuItems()"
        (contentItemDeleted)="store.handleDeletedObject($event)"
        (contentItemAddTo)="onContentItemAddTo($event)"
      ></bd-content-details-container>
    </ng-template>
    <bd-content-open-container
      [visible]="store.contentOpenDialogVisible()"
      [elementCollection]="store.elementQuery()"
      [elementCollectionLoading]="
        store.searchResultsStoreProperties().allRemainingSearchResultsLoading
      "
      [numberOfCollectionElements]="store.numberOfCollectionElements()"
      (visibleChange)="store.updateContentOpenDialogVisible($event)"
      (cancelContentOpen)="onCancelContentOpen()"
    />
    @if (store.featureFlagsStore.populationsEnabled()) {
      <bd-rich-menu
        #createPopulationMenu
        data-id="create-population-menu"
        [headerTextKey]="'saveAsPopulationMenu.header'"
        [tScope]="'featureSearch'"
        [menuItems]="
          store.populationsStoreProperties().createPopulationMenuItems
        "
      ></bd-rich-menu>
      <bd-create-population-modal
        [visible]="
          store.populationsStoreProperties().createPopulationModalVisible
        "
        [dataForPopulationLoading]="
          store.populationsStoreProperties().dataForPopulationLoading
        "
        (visibleChange)="store.updateCreatePopulationModalVisible($event)"
        [populationType]="
          store.populationsStoreProperties().chosenPopulationType
        "
        [numberOfFilters]="store.populationsStoreProperties().filtersCount"
        [numberOfSelectedObjects]="
          store.populationsStoreProperties().selectedObjectsCount
        "
        [showWarningMessageForDynamicPopulation]="
          store.showWarningMessageForDynamicPopulation()
        "
        (saveAsPopulation)="onSaveAsPopulation($event)"
        (cancelSaveAsPopulation)="onCancelSaveAsPopulation()"
      />
    }
    <bd-status-dialog
      data-id="delete-view-dialog"
      [dialogSettings]="deleteViewDialogSettings()"
      (confirm)="onDeleteViewConfirm()"
      (dismiss)="onDeleteViewDismiss()"
    >
      @let viewName = viewToDelete()?.name ?? '';
      <p class="bd-body-large mb-3">
        {{ t('featureSearch.deleteViewDialog.description') }}
      </p>
      <p class="bd-body-large">
        {{ t('featureSearch.deleteViewDialog.question', { viewName }) }}
      </p>
    </bd-status-dialog>
  }
  @if (smartFilterLoadingDialogProperties) {
    <bd-dialog
      data-id="loading-smart-filters-dialog"
      [visible]="store.searchResultsStoreProperties().smartFiltersLoading"
      [dialogProperties]="smartFilterLoadingDialogProperties"
      (dismiss)="onCancelSmartFiltersLoading()"
    >
      <div class="flex flex-col items-center justify-center px-[38px]">
        <p-progress-spinner
          strokeWidth="4"
          [style]="{ width: '56px', height: '56px' }"
        />
        <p
          data-id="loading-smart-filters-dialog-headline"
          class="bd-headline-small mt-6 mb-2"
        >
          {{ t('featureSearch.loadingSmartFiltersDialog.headline') }}
        </p>
        <p
          data-id="loading-smart-filters-dialog-description"
          class="bd-body-large text-center"
        >
          {{ t('featureSearch.loadingSmartFiltersDialog.description') }}
        </p>
      </div>
      <div footer class="flex justify-end mt-6">
        <p-button
          data-id="loading-smart-filters-dialog-cancel-button"
          (onClick)="onCancelSmartFiltersLoading()"
          [label]="
            t('featureSearch.loadingSmartFiltersDialog.cancelButtonLabel')
          "
        >
        </p-button>
      </div>
    </bd-dialog>
  }
  @if (smartFiltersErrorDialogProperties) {
    <bd-dialog
      data-id="smart-filters-error-dialog"
      [visible]="store.smartFiltersErrorDialogVisibility()"
      (dismiss)="refineSmartQuery()"
      [dialogProperties]="smartFiltersErrorDialogProperties"
    >
      <div class="flex flex-col items-center justify-center mx-10 mb-12">
        <i class="ui-cancel bd-error-icon" aria-hidden="true"></i>
        <p class="bd-headline-small mt-6 mb-2">
          {{ t('featureSearch.smartFiltersErrorDialog.headline') }}
        </p>
        <p class="bd-body-large text-center">
          {{ t('featureSearch.smartFiltersErrorDialog.descriptionLineOne') }}
        </p>
        <p class="bd-body-large text-center">
          {{ t('featureSearch.smartFiltersErrorDialog.descriptionLineTwo') }}
        </p>
      </div>
      <div class="flex gap-x-4 justify-end bd-neutral" footer>
        <p-button
          data-id="retry-search-btn"
          [outlined]="true"
          [label]="
            t('featureSearch.smartFiltersErrorDialog.retrySearchButtonLabel')
          "
          (onClick)="retrySmartQuery()"
        ></p-button>
        <p-button
          data-id="refine-search-btn"
          [label]="
            t('featureSearch.smartFiltersErrorDialog.refineSearchButtonLabel')
          "
          (onClick)="refineSmartQuery()"
        ></p-button>
      </div>
    </bd-dialog>
  }

  @if (inviteWorkspaceDialogProperties$ | async; as dialogProperties) {
    <bd-dialog
      [visible]="(inviteWorkspaceDialogVisible$ | async) ?? false"
      (visibleChange)="inviteWorkspaceDialogVisible$.next($event)"
      [dialogProperties]="dialogProperties"
      [showFooter]="false"
      extraStyleClass="bd-workspace-invite-dialog"
      data-id="invite-workspace-dialog"
      ><bd-workspace-invite-container
        class="flex flex-col flex-1 min-h-0"
        [workspace]="workspaceToInvite()"
        [visible]="(inviteWorkspaceDialogVisible$ | async) ?? false"
        [updateError$]="workspaceUpdateError$"
        (workspaceUpdate)="onInviteWorkspaceUpdate($event)"
      />
    </bd-dialog>
  }

  <bd-dialog
    [visible]="(archiveWorkspaceDialogVisible$ | async) ?? false"
    (visibleChange)="archiveWorkspaceDialogVisible$.next($event)"
    (dismiss)="onArchiveWorkspaceCancel()"
    [dialogProperties]="archiveWorkspaceDialogProperties"
    [showFooter]="false"
    data-id="archive-workspace-dialog"
  >
    <div
      *transloco="let tWorkspaces; scope: 'featureWorkspaces'"
      class="bd-dialog-content"
    >
      <section class="bd-dialog-section">
        <i class="ui-error bd-failure"></i>
        <p class="bd-headline-small">
          {{ tWorkspaces('featureWorkspaces.archiveWorkspaceModal.title') }}
        </p>
        <span
          class="bd-body-large text-center"
          [innerHTML]="
            tWorkspaces('featureWorkspaces.archiveWorkspaceModal.description', {
              workspaceName: pendingArchiveWorkspaceName(),
            }) | highlight: pendingArchiveWorkspaceName()
          "
        ></span>
      </section>
      <section class="bd-dialog-actions">
        <p-button
          data-id="archive-workspace-confirm-button"
          styleClass="bd-danger"
          (onClick)="onArchiveWorkspaceConfirm()"
        >
          <span class="uppercase">{{
            tWorkspaces('featureWorkspaces.archiveWorkspaceModal.confirm')
          }}</span>
        </p-button>
        <p-button
          data-id="archive-workspace-cancel-button"
          [link]="true"
          styleClass="bd-danger"
          (onClick)="onArchiveWorkspaceCancel()"
        >
          <span class="uppercase">{{
            tWorkspaces('featureWorkspaces.archiveWorkspaceModal.dismiss')
          }}</span>
        </p-button>
      </section>
    </div>
  </bd-dialog>

  <bd-edit-data-dialog
    [loading]="
      (store.searchResultsStoreProperties().editDataLoading$ | async) ?? false
    "
    [selectedObjects]="store.selectedObjects()"
    [showWarning]="store.editDataWarningVisible()"
    (cancelLoading)="cancelEditDataLoading()"
    (confirm)="onConfirmEditData($event)"
    (dismiss)="onDismissEditData()"
  ></bd-edit-data-dialog>
</div>

@if (store.showDrawerBackdrop()) {
  <div
    class="drawer-backdrop"
    (click)="store.showUnsavedPublishedItemWarning()"
    (keydown)="store.showUnsavedPublishedItemWarning()"
  ></div>
}

<ng-container *transloco="let tWS; scope: 'featureWorkspaces'">
  <bd-content-open-container
    data-id="copy-view-to-frame-dialog"
    [visible]="(copyViewToFrameDialogVisible$ | async) ?? false"
    (visibleChange)="copyViewToFrameDialogVisible$.next($event)"
    (selectionConfirm)="onCopyViewToFrameConfirm($event)"
    [showOnlyWorkspaceStep]="true"
    [dialogTitle]="tWS('featureWorkspaces.workspace.addViewToFrameTitle')"
  />
</ng-container>
<bd-snackbar-toast [key]="'search-link-copied-snackbar'"></bd-snackbar-toast>
